import React from "react";
import { createRoot } from "react-dom/client";
import AppContainer from "./containers/AppContainer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLeitner from "./Leitner/AppLeitner"
import Notfound from "./containers/Notfound"
import AppOauthError from "./containers/AppOauthError"
import Referral from "./Referral/Referral"
import PaymentVerify from "./payment/PaymentVerify"
import GoogleLogIn from "./containers/GoogleLogIn"
import AddGmailToAccount from "./containers/AddGmailToAccount"
import PrivacyPolicy from "./StaticPages/PrivacyPolicy"
import ForumLogin from "./ForumLogin/ForumLogin"
import SingOutForum from "./ForumLogin/SingOutForum/SingOutForum"
import EditProfileForum from "./ForumLogin/EditProfileForum/EditProfileForum"
import Sub from "./Sub/Sub"
import CompareSubs from "./CompareSubs/CompareSubs"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import AppRedirect from "./containers/AppRedirect";

const root = createRoot(document.getElementById("root"));

root.render(
    // <React.StrictMode> 
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<AppContainer />} />
            <Route path="/appleitner" element={<AppLeitner />} />
            <Route path="/referral/*" element={<Referral />} />
            <Route path="/googlelogin" element={<GoogleLogIn />} />
            <Route path="/getgmail" element={<AddGmailToAccount />} />
            <Route path="/payment/verify/*" element={<PaymentVerify />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/singInForum" element={<ForumLogin />} />
            <Route path="/singOutForum" element={<SingOutForum />} />
            <Route path="/editprofileforum" element={<EditProfileForum />} />
            <Route path="/sub/*" element={<Sub />} />
            <Route path="/comparesubs" element={<CompareSubs />} />
            <Route path="/app/oauth/*" element={<AppOauthError />} />
            <Route path="/app" element={<AppRedirect />} />
            <Route path="*" element={<Notfound />} />
        </Routes>
    </BrowserRouter>
    // </React.StrictMode>
);

serviceWorkerRegistration.register();